import { AuthenticatedRouteProvider } from "@/context/authenticated-route";
import { routeLoaderApiClient } from "@/lib/api";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated-user")({
  beforeLoad: async () => {
    const res = await routeLoaderApiClient.user.$get();
    if (res.ok === false) {
      throw new Error("Failed to fetch user");
    }

    const { user } = await res.json();
    if (user == null) {
      throw redirect({
        to: "/login",
        search: {
          url: window.location.href,
        },
      });
    }
  },
  component: AuthenticatedUserRoute,
});

function AuthenticatedUserRoute() {
  return (
    <AuthenticatedRouteProvider type="user">
      <Outlet />
    </AuthenticatedRouteProvider>
  );
}
